import { render } from "./PaymentFailPage.vue?vue&type=template&id=9e53ea5c&scoped=true"
import script from "./PaymentFailPage.vue?vue&type=script&lang=js"
export * from "./PaymentFailPage.vue?vue&type=script&lang=js"

import "./PaymentFailPage.vue?vue&type=style&index=0&id=9e53ea5c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e53ea5c"]])

export default __exports__